import { createSlice } from "@reduxjs/toolkit";
import { getAxios, getRRAxios, postAxios, postRRAxios } from "./axiosActions";
import { fetchGPTUsageData, setInput } from "./logs";
import AppConfig from "../../appConfig";
import _ from 'lodash';
import toast from "../../common/toastNotistack";
import { convertArrayToDictionary } from "../../common/utils";
import { getOtherFilter, seOtherFilter, setOtherFilter } from "../../common/utils/setOtherFilter";
import { isValidJSON } from "../../ui/components/common/reviewComponents/reviewUtils";
import { setFactLocalState } from "./facts";
const updateReviewText = (data, bindData, fieldName) => {
  const updateData = convertArrayToDictionary(bindData, fieldName);
  return _.map(data, (it) => {
    const obj = updateData[it?.reviewId]
    it['reviewText'] = obj?.r;
    it['responseText'] = obj?.p;
    it['reviewContext'] = obj?.rc;
    return it;
  });
};
export const initialState = {
  loadingReviews: false,
  loadingAddInternalReview: false,
  loadingEditInternalReview: false,
  loadingDeleteInternalReview: false,
  loadingGenerateResponse: false,
  loadingExecutePromptMultiple: false,
  loadingExecutePromptWithJsonData: false,
  isRecalculateTS: false,
  hasErrorRecalculateTS: false,
  hasErrors: false,
  reviews: [],
  unfilteredReviews:[],
  similarReviews: [],
  saveExampleReview: [],
  deleteExampleReview: [],
  addInternalReview: [],
  editInternalReview: [],
  deleteInternalReview: [],
  generateResponse: [],
  executePromptMultiple: {},
  executePromptMultipleFact: {},
  executePromptWithJsonData: [],
  reviewTopicDetails: [],
  loadingReviewTopicDetails: false,
  errorRdviewTopicDetails: false,
  reviewIssues: [],
  LogsData: [],
  localState:{openBulk: false, },
	
};

const reviewsSlice = createSlice({
  name: "reviews",
  initialState,
  reducers: {
    getReviews: (state) => {
      state.loadingReviews = true;
    },
    getReviewsSuccess: (state, { payload }) => {
      state.reviews = payload?.responseContent ?? [];
      state.unfilteredReviews = payload?.responseContent ?? [];
      state.loadingReviews = false;
      state.hasErrors = false;
    },
    getReviewsFailure: (state) => {
      state.loadingReviews = false;
      state.hasErrors = true;
    },
    GetLogsFailure: state => {
      state.loading = false;
      state.hasErrors = true;
   },
 
 
   GetLogsSuccess: (state, { payload }) => {
      state.LogsData = payload ?? [];
      state.loading = false;
      state.hasErrors = false;
   },
 
   GetLogs: state => {
      state.loading = true;
   },
    getSimilarReviews: (state) => {
      state.loadingReviews = true;
    },
    getSimilarReviewsSuccess: (state, { payload }) => {
      state.similarReviews = payload;
      state.loadingReviews = false;
      state.hasErrors = false;
    },
    getSimilarReviewsFailure: (state) => {
      state.loadingReviews = false;
      state.hasErrors = true;
    },

    getReviewDataTopics: (state) => {
      state.loadingReviewDataTopics = true;
      state.errorReviewDataTopics = false;
    },
    getSaveExampleReview: (state) => {
      state.loadingReviews = true;
    },
    getSaveExampleReviewSuccess: (state, { payload }) => {
      state.saveExampleReview = payload;
      state.loadingReviews = false;
      state.hasErrors = false;
    },
    getSaveExampleReviewFailure: (state) => {
      state.loadingReviews = false;
      state.hasErrors = true;
    },
    getDeleteExampleReview: (state) => {
      state.loadingReviews = true;
    },
    getDeleteExampleReviewSuccess: (state, { payload }) => {
      state.deleteExampleReview = payload;
      state.loadingReviews = false;
      state.hasErrors = false;
    },
    getDeleteExampleReviewFailure: (state) => {
      state.loadingReviews = false;
      state.hasErrors = true;
    },
    getAddInternalReview: (state) => {
      state.loadingAddInternalReview = true;
    },
    getAddInternalReviewSuccess: (state, { payload }) => {
      // state.reviews = payload;
      state.loadingAddInternalReview = false;
      state.hasErrors = false;
    },
    getAddInternalReviewFailure: (state) => {
      state.loadingAddInternalReview = false;
      state.hasErrors = true;
    },
    getEditInternalReview: (state) => {
      state.loadingEditInternalReview = true;
    },
    getEditInternalReviewSuccess: (state, { payload }) => {
      state.editInternalReview = payload;
      state.loadingEditInternalReview = false;
      state.hasErrors = false;
    },
    getEditInternalReviewFailure: (state) => {
      state.loadingEditInternalReview = false;
      state.hasErrors = true;
    },
    getDeleteInternalReview: (state) => {
      state.loadingDeleteInternalReview = true;
    },
    getDeleteInternalReviewSuccess: (state, { payload }) => {
      state.deleteInternalReview = payload;
      state.loadingDeleteInternalReview = false;
      state.hasErrors = false;
    },
    getDeleteInternalReviewFailure: (state) => {
      state.loadingDeleteInternalReview = false;
      state.hasErrors = true;
    },
    getGenerateResponse: (state) => {
      state.loadingGenerateResponse = true;
    },
    getGenerateResponseSuccess: (state, { payload }) => {
      state.generateResponse = payload?.responseContent;
      state.loadingGenerateResponse = false;
      state.hasErrors = false;
    },
    getGenerateResponseFailure: (state) => {
      state.loadingGenerateResponse = false;
      state.hasErrors = true;
    },
    getExecutePromptMultiple: (state) => {
      state.loadingExecutePromptMultiple = true;
    },
    getExecutePromptWithJsonData: (state) => {
      state.loadingExecutePromptWithJsonData = true;
    },
    getReviewsDataSuccess: (state, { payload }) => {
      state.reviews = updateReviewText(state.reviews, payload, 'id');
      state.unfilteredReviews = updateReviewText(state.reviews, payload, 'id');
    },
    getReviewDataFailure: (state, { loading }) => {
      state[loading] = false;
      state.hasErrors = true;
    },
    getExecutePromptMultipleSuccess: (state, { payload }) => {
      if (!state.executePromptMultiple) {
        state.executePromptMultiple = {};
      }
      let executePromptMultiple = { ...state.executePromptMultiple };
      let executePromptMultipleFact = { ...state.executePromptMultipleFact };
      
      executePromptMultiple[payload.id] = payload?.response?.responseContent ?? [];
      executePromptMultipleFact[payload.id] = payload?.response ?? [];
      state.executePromptMultipleFact = executePromptMultipleFact;
      state.executePromptMultiple = executePromptMultiple;
      state.loadingExecutePromptMultiple = false;
      state.hasErrors = false;
    },
    getExecutePromptMultipleFailure: (state) => {
      state.loadingExecutePromptMultiple = false;
      state.hasErrors = true;
    },
    getExecutePromptWithJsonDataSuccess: (state, { payload }) => {
      let executePromptWithJsonData = state['executePromptWithJsonData'] ? _.cloneDeep(state['executePromptWithJsonData']) : {};
      executePromptWithJsonData[payload.id] = payload?.response ?? [];
      state.executePromptWithJsonData = executePromptWithJsonData;
      state.loadingExecutePromptWithJsonData = false;
      state.hasErrors = false;
    },
    getExecutePromptWithJsonDataFailure: (state) => {
      state.loadingExecutePromptMultiple = false;
      state.hasErrors = true;
    },
    recalculateTopicSentimentData: (state) => {
      state.isRecalculateTS = true;
    },
    recalculateTopicSentimentDataSuccess: (state, { payload }) => {
      if (state.reviews?.length > 0) {
        state.reviews = _.map(state.reviews, (item) => {
          if (payload.reviewId === item.reviewId) {
            item.topicData = payload.data;
          }
          return item;
        });
      }
      if (state.unfilteredReviews?.length > 0) {
        state.unfilteredReviews = _.map(state.unfilteredReviews, (item) => {
          if (payload.reviewId === item.reviewId) {
            item.topicData = payload.data;
          }
          return item;
        });
      }
      //state.reviews = { reviewId: payload?.reviewId, topicData: payload.data }
      state.isRecalculateTS = false;
      state.hasErrorRecalculateTS = false;
    },
    recalculateTopicSentimentDataFailure: (state) => {
      state.isRecalculateTS = false;
      state.hasErrorRecalculateTS = true;
    },
    reviewTopicDetails: state => {
      state.loadingReviewTopicDetails = true;
      state.errorRdviewTopicDetails = false
    },
    reviewTopicDetailsSuccess: (state, { payload }) => {
      state.loadingReviewTopicDetails = false;
      state.reviewTopicDetails = payload;
      state.errorRdviewTopicDetails = false
    },
    reviewTopicDetailsFailure: state => {
      state.loadingReviewTopicDetails = false;
      state.errorRdviewTopicDetails = false;
    }, createIssue: state => {
      state.isCreateIssue = true;
      state.errorCreateIssue = false;
    },
    createIssueSuccess: state => {
      state.isCreateIssue = false;
      state.errorCreateIssue = false;
    },
    createIssueFailure: state => {
      state.isCreateIssue = false;
      state.errorCreateIssue = true;
    },
    createIssueList: state => {
      state.isCreateIssue = true;
      state.errorCreateIssue = false;
    },
    createIssueSuccessList: state => {
      state.isCreateIssue = false;
      state.errorCreateIssue = false;
    },
    createIssueFailureList: state => {
      state.isCreateIssue = false;
      state.errorCreateIssue = true;
    },
    setReviewSourceFilter:(state,{payload})=>{
      
      const tempReviews=_.clone(state.unfilteredReviews)
      const sourceArr=_.map(payload,it=>_.parseInt(it))
      if(!_.isEqual(sourceArr,[-1]))
      {state.reviews=_.filter(tempReviews,it=>_.includes(sourceArr,it.sourceType))}
      else{
        state.reviews=state.unfilteredReviews
      }
    },
    getBulkDialogStatus: (state, { payload }) => {
      if (payload) {
        state.localState.openBulk = payload;
      } else {
        state.localState.openBulk = !state.localState.openBulk;
      }
    }
  },
});

export const {
  getReviews,
  getReviewsSuccess,
  getReviewsFailure,
  getSimilarReviews,
  getReviewDataTopics,
  getSimilarReviewsSuccess,
  getSimilarReviewsFailure,
  getSaveExampleReview,
  getSaveExampleReviewSuccess,
  getSaveExampleReviewFailure,
  getDeleteExampleReview,
  getDeleteExampleReviewSuccess,
  getDeleteExampleReviewFailure,
  getAddInternalReview,
  getAddInternalReviewSuccess,
  getAddInternalReviewFailure,
  getEditInternalReview,
  getEditInternalReviewSuccess,
  getEditInternalReviewFailure,
  getDeleteInternalReview,
  getDeleteInternalReviewSuccess,
  getDeleteInternalReviewFailure,
  getGenerateResponse,
  getGenerateResponseSuccess,
  getGenerateResponseFailure,
  getExecutePromptMultiple,
  getExecutePromptMultipleSuccess,
  getExecutePromptMultipleFailure,
  recalculateTopicSentimentData,
  recalculateTopicSentimentDataSuccess,
  recalculateTopicSentimentDataFailure,getReviewsDataSuccess,getReviewDataFailure,setReviewSourceFilter,
  reviewTopicDetails, reviewTopicDetailsFailure, reviewTopicDetailsSuccess, createIssueSuccess, createIssueFailure, createIssue, createIssueSuccessList, createIssueFailureList, createIssueList,
  GetLogs,
	GetLogsSuccess,
	GetLogsFailure,
  getExecutePromptWithJsonData,
  getExecutePromptWithJsonDataSuccess, getExecutePromptWithJsonDataFailure, getBulkDialogStatus
} = reviewsSlice.actions;
export const reviewsSelector = (state) => state.reviews;
export default reviewsSlice.reducer;

export function fetchReviews(locationId) {
  return async (dispatch) => {
    dispatch(getReviews());
    try {
      const params = { callTime: new Date() };
      const data = await getRRAxios(
        "api/Reviews/GetReviews",
        // startDate +
        // "&endDate=" +
        // endDate +
        // "&companyId=" +
        // companyId,
        { params: params }
      );
      dispatch(getReviewsSuccess(data));
      if(data?.responseContent?.length > 10000){
        dispatch(fetchReviewsData());
      }
    } catch (error) {
      dispatch(getReviewsFailure());
    }
  };
}
export function fetchReviewsData() {
  return async (dispatch) => {
    // dispatch(getReviewsData());
    const requstUrl = "api/Reviews/GetReviewsText";
    // + (from && to ? ("&from=" + from + "&to=" + to) : '')
    try {
      const params = { callTime: new Date() };
      const data = await getRRAxios(requstUrl, { params: params }, true);
      dispatch(getReviewsDataSuccess(data));   
    } catch (error) {
      dispatch(getReviewDataFailure());
    }
  };
}

export function fetchSimilarReviews(reviewId) {
  return async (dispatch) => {
    dispatch(getSimilarReviews());
    try {
      const params = { callTime: new Date() };
      const data = await getRRAxios(
        "api/Reviews/GetReviewDetails?reviewId=" + reviewId,
        { params: params }
      );
      dispatch(getSimilarReviewsSuccess({ ...data, reviewId: reviewId }));
    } catch (error) {
      dispatch(getSimilarReviewsFailure());
    }
  };
}

export const triggerSaveExampleReview = (data, startDate, endDate, selectedCompany) => {
  return async (dispatch) => {
    dispatch(getSaveExampleReview(data));
    try {
      const response = await postRRAxios("api/Reviews/SaveExampleReview", {
        params: data,
      });
      await dispatch(getSaveExampleReviewSuccess(response));
      if (data?.reviewId) {
        dispatch(fetchSimilarReviews(data?.reviewId));
        if (startDate && endDate && selectedCompany) {
          await dispatch(fetchReviews(startDate, endDate, selectedCompany))
        }
      }
    } catch (error) {
      dispatch(getSaveExampleReviewFailure());
    }
  };
};
export const triggerEditExampleReview = (data, reviewId) => {
  return async (dispatch) => {
    dispatch(getSaveExampleReview(data));
    try {
      const response = await postRRAxios("api/Reviews/EditExampleReview", {
        params: data,
      });
      await dispatch(getSaveExampleReviewSuccess(response));
      if (reviewId) {
        await dispatch(fetchSimilarReviews(reviewId));
        toast('Training example asved successfully!', { variant: 'success' })
      }
    } catch (error) {
      dispatch(getSaveExampleReviewFailure());
    }
  };
};

export function triggerDeleteExampleReview(
  reviewId,
  exampleReviewId = false,
  selectedReviewId,
  startDate, endDate, selectedCompany
) {
  return async (dispatch) => {
    dispatch(getDeleteExampleReview());
    try {
      const params = { callTime: new Date() };
      let str = "reviewId=" + reviewId;
      if (exampleReviewId) {
        str += "&exampleReviewId=" + exampleReviewId;
      }
      const data = await getRRAxios("api/Reviews/DeleteExampleReview?" + str, {
        params: params,
      });
      dispatch(getDeleteExampleReviewSuccess({ exampleReviewId, reviewId }));
      if (data.statusCode === 200) {
        await dispatch(fetchSimilarReviews(reviewId));
        if (startDate && endDate && selectedCompany) {

          await dispatch(fetchReviews(startDate, endDate, selectedCompany))
        }
      }
    } catch (error) {
      dispatch(getDeleteExampleReviewFailure());
    }
  };
}

export const fetchReviewSentiments = (locationId, companyId) => {
  return async (dispatch) => {
    try {
      const params = { callTime: new Date() };
      const response = await getAxios(
        "api/Processes/ExecuteBP?processId=C15C012E-A9F6-4592-9F59-FE3474068C6E&companyId=" +
        companyId +
        "&locationId=" +
        locationId,
        { params: params }
      );
    } catch (error) {
      console.log(error);
    }
  };
};

export const fetchReviewTopicSentiment = (locationId, companyId) => {
  return async (dispatch) => {
    try {
      const params = { callTime: new Date() };
      const response = await getAxios(
        "api/Processes/ExecuteBP?processId=57E9F5F7-59C2-4529-B9EE-F6D9F9620FF1&companyId=" +
        companyId +
        "&locationId=" +
        locationId,
        { params: params }
      );
    } catch (error) {
      console.log(error);
    }
  };
};
export const triggerAddInternalReview = (
  data,
  companyId,
  startDate,
  endDate
) => {
  return async (dispatch) => {
    dispatch(getAddInternalReview(data));
    try {
      const response = await postRRAxios("playground/Reviews/AddInternalReview", {
        params: data,
      });
      await dispatch(getAddInternalReviewSuccess(response));
      await dispatch(fetchReviews(startDate, endDate, companyId));
      // await dispatch(fetchReviewTopicSentiment(locationId, companyId))
    } catch (error) {
      dispatch(getAddInternalReviewFailure());
    }
  };
};

export const triggerEditInternalReview = (
  data,
  companyId,
  startDate,
  endDate
) => {
  return async (dispatch) => {
    dispatch(getEditInternalReview(data));
    try {
      const response = await postRRAxios("playground/Reviews/EditInternalReview", {
        params: {
          sourceId: data?.sourceId,
          reviewId: data?.reviewId,
          authorName: data?.authorName,
          reviewDate: data?.reviewDate,
          rating: data?.rating,
          reviewText: data?.reviewText,
          responseText: data?.responseText,
          responseDate: data?.responseDate
        },
      });
      await dispatch(getEditInternalReviewSuccess(response));
      await dispatch(fetchReviews(startDate, endDate, companyId));
    } catch (error) {
      dispatch(getEditInternalReviewFailure());
    }
  };
};

export function triggerDeleteInternalReview(reviewId) {
  return async (dispatch) => {
    dispatch(getDeleteInternalReview());
    try {
      const params = { callTime: new Date() };
      const data = await getRRAxios(
        "playground/Reviews/DeleteInternalReviewId?reviewId=" + reviewId,
        { params: params }
      );
      dispatch(getDeleteInternalReviewSuccess(data));
    } catch (error) {
      dispatch(getDeleteInternalReviewFailure());
    }
  };
}

export const fetchModifiedGenerateResponse = (data, companyId) => {
  return async (dispatch) => {
    dispatch(getGenerateResponse(data));
    try {
      const response = await postAxios("api/OpenAi/ExecutePromptMultiple", {
        params: data,
      });
      await dispatch(getGenerateResponseSuccess(response));
      if (companyId) {
        dispatch(
          setInput({})
        );
      }
    } catch (error) {
      dispatch(getGenerateResponseFailure());
    }
  };
};

export const triggerExecutePromptMultiple = (data, companyId, id) => {
  return async (dispatch, getState) => {
    dispatch(getExecutePromptMultiple(data));
    try {
      const response = await postAxios("api/OpenAi/ExecutePromptMultiple", {
        params: data,
      });
      if(response){
        await dispatch(getExecutePromptMultipleSuccess({ response, id }));
        const subType = data?.ExtraData?.subType;
        const isWebsiteResearch = subType === 'Website Research';
        const isFactDevelopment = subType === 'Facts';

        // Only persist facts-page runs into fact local state (not other ExecutePromptMultiple callers)
        if (isWebsiteResearch || isFactDevelopment) {
          const timestamp = new Date().toISOString();
          const factState = getState().facts.localState || {};
          const factInputData = factState?.factDevelopment?.inputData || {};

          if (isFactDevelopment) {
            // Keep Website Research in factDevelopment; store Fact Development under FactData
            const factDataOutput = {
              ...response,
              createdAt: timestamp,
            };
            setOtherFilter('FactData', JSON.stringify(factDataOutput));
            dispatch(setFactLocalState({
              key: 'FactData',
              data: { outputData: factDataOutput },
            }));
          } else {
            // Always replace with latest WR response (including GPTData for Copy Log)
            const updatedData = {
              ...response,
              createdAt: timestamp,
              inputData: factInputData,
            };
            setOtherFilter('factDevelopment', JSON.stringify(updatedData));
            dispatch(setFactLocalState({
              key: 'factDevelopment',
              data: {
                inputData: {
                  ...factInputData,
                  previousResponseId:
                    updatedData?.previousResponse?.[0]?.ResponseId ??
                    updatedData?.previousResponse?.[0]?.responseId,
                },
                outputData: updatedData,
              },
            }));

            // Website Research only: clear dedicated FactData
            setOtherFilter('FactData', null);
            dispatch(setFactLocalState({ key: 'FactData', data: null }));
          }
        }
      }
      if (companyId) {
        dispatch(
          setInput({})
        );
      }
      return response || null;
    } catch (error) {
      dispatch(getExecutePromptMultipleFailure());
      return null;
    }
  };
};
export const triggerExecutePromptWithJsonData = (data, companyId, id) => {
  return async (dispatch) => {
    dispatch(getExecutePromptWithJsonData(data));
    try {
      const response = await postAxios("api/OpenAi/ExecutePromptWithJsonData", {
        params: data,
      });
      
      
     // const response = "Ww0KICAie1xuICBcImNoYXRfaWRcIjogXCIyMTU0Njk3ODk1ODI0ODNcIixcbiAgXCJzZWN0aW9uXzFfdG9waWNcIjogW1xuICAgIFwiQm9va2luZzogQm9va2luZyBjb25maXJtYXRpb24gbm90IGRlbGl2ZXJlZFwiXG4gIF0sXG4gIFwic2VjdGlvbl8xX3RvcGljX3JhdGlvbmFsZVwiOiBcIlRoZSB1c2VyIGluaXRpYXRlZCB0aGUgY2hhdCB0byBoYXZlIHRoZWlyIGJvb2tpbmcgY29uZmlybWF0aW9uIGVtYWlsIHJlc2VudCBhbmQgbWVudGlvbmVkIGFuIGluY29ycmVjdCBlbWFpbCBhZGRyZXNzLCBpbmRpY2F0aW5nIGEgcHJvYmxlbSB3aXRoIHJlY2VpdmluZyB0aGUgYm9va2luZyBjb25maXJtYXRpb24uXCIsXG4gIFwic2VjdGlvbl8yX2hvd19jaGF0X2VuZGVkXCI6IFwiVW5jbGVhciBvciBhYnJ1cHQgZW5kaW5nIHdpdGggbm8gY29uZmlybWF0aW9uIGZyb20gY3VzdG9tZXJcIixcbiAgXCJzZWN0aW9uXzJfaG93X2NoYXRfZW5kZWRfcmF0aW9uYWxlXCI6IFwiQWZ0ZXIgdGhlIGFkbWluIGNsYXJpZmllZCB0aGF0IHRoZSByZXNlcnZhdGlvbiB3YXMgbm90IGZvdW5kIG9uIEZlcnJ5aG9wcGVyIGFuZCBhZHZpc2VkIHRoZSBjdXN0b21lciB0byBjb250YWN0IHRoZSBhZ2VuY3kgd2hlcmUgdGhlIHRpY2tldHMgd2VyZSBwdXJjaGFzZWQsIHRoZSBjaGF0IGVuZGVkIHdpdGhvdXQgYW55IGV4cGxpY2l0IGNvbmZpcm1hdGlvbiBvciBmdXJ0aGVyIHJlc3BvbnNlIGZyb20gdGhlIGN1c3RvbWVyLlwiLFxuICBcInNlY3Rpb25fM19odW1hbl9pbnRlcmFjdGlvblwiOiB7XG4gICAgXCJyZXF1ZXN0ZWRcIjogXCJZZXNcIixcbiAgICBcInByb3ZpZGVkXCI6IFwiWWVzIOKAlCBkZWxheWVkXCJcbiAgfSxcbiAgXCJzZWN0aW9uXzRfZGVsYXlfZnJ1c3RyYXRpb25cIjoge1xuICAgIFwidW5hbnN3ZXJlZF91c2VyX21lc3NhZ2VzXCI6IDEsXG4gICAgXCJ1bmFuc3dlcmVkX3JhdGlvbmFsZVwiOiBcIkJldHdlZW4gdGhlIGxpdmUgY2hhdCByZXF1ZXN0IGFuZCB0aGUgYWRtaW4ncyBmaXJzdCByZXNwb25zZSwgdGhlIHVzZXIgc2VudCBvbmUgbWVzc2FnZSAoJ09rJykgdGhhdCB3YXMgbm90IGFuc3dlcmVkIGJ5IGEgaHVtYW4gYWdlbnQuXCIsXG4gICAgXCJmcnVzdHJhdGlvbl9zaWduYWxzXCI6IFwiVGhlIHVzZXIgZGlkIG5vdCBzaG93IG92ZXJ0IGZydXN0cmF0aW9uIHRocm91Z2ggcmVwZWF0ZWQgbWVzc2FnaW5nIG9yIGFuZ3J5IHRvbmUsIGFsdGhvdWdoIHRoZSBvdmVyYWxsIGxvdyByYXRpbmcgaW5kaWNhdGVzIGRpc3NhdGlzZmFjdGlvbi5cIlxuICB9XG59Ig0KXQ";
      
      let processedResponse;
      
      if (typeof response === 'string') {

        try {
          const decodedResponse = atob(response);
          const parsedData = JSON.parse(decodedResponse);
          processedResponse =parsedData;
        } catch (decodeError) {
          console.error('Error decoding Base64 response:', decodeError);
          processedResponse = response;
        }
      } else if (response) {
        
        try {
          const decodedResponse = atob(response);
          const parsedData = JSON.parse(decodedResponse);
          processedResponse = parsedData;
        } catch (decodeError) {
          console.error('Error decoding Base64 response:', decodeError);
          processedResponse = response;
        }
      } else {
        processedResponse = response;
      }
      
      await dispatch(getExecutePromptWithJsonDataSuccess({ response: processedResponse, id }));
      dispatch(getBulkDialogStatus(true));
    } catch (error) {
      console.error('API call error:', error);
      dispatch(getExecutePromptWithJsonDataFailure());
    }
  };
};

export function triggerDeleteCustomExampleReview(exampleReviewId, reviewId) {
  return async (dispatch) => {
    dispatch(getDeleteExampleReview());
    try {
      const params = { callTime: new Date() };
      const data = await getRRAxios("api/Reviews/DeleteExampleReview?exampleReviewId=" + exampleReviewId,{ params: params });
      await dispatch(getDeleteExampleReviewSuccess(data));
      if (reviewId) {
        dispatch(fetchSimilarReviews(reviewId));
      }
    } catch (error) {
      dispatch(getDeleteExampleReviewFailure());
    }
  };
}


export function getReviewTopicDetails(reviewId) {
  return async (dispatch) => {
    dispatch(reviewTopicDetails());
    try {
      const params = { callTime: new Date() };
      const data = await getRRAxios(
        "api/Reviews/GetReviewTopicDetails?reviewId=" +
        reviewId,
        { params: params }
      );
      await dispatch(fetchSimilarReviews(reviewId))
      await dispatch(reviewTopicDetailsSuccess(data));
    } catch (error) {
      dispatch(reviewTopicDetailsFailure());
    }
  };
}
export function recalculateTopicSentiments(reviewId) {
  return async (dispatch) => {
    dispatch(recalculateTopicSentimentData());
    try {
      const response = await getRRAxios(
        "api/ReviewSentiments/RecalculateReviewTopicSentiments?reviewId=" +
        reviewId,
        { params: {} }
      );
      if (response) {
        await dispatch(
          recalculateTopicSentimentDataSuccess({ data: response, reviewId })
        );
            await dispatch(fetchSimilarReviews(reviewId))
        //    await dispatch(fetchReviews(locationIds, startDate,endDate))
      } else {
        dispatch(recalculateTopicSentimentDataFailure());
      }
    } catch (error) {
      dispatch(recalculateTopicSentimentDataFailure());
    }
  };
}



export const triggerRegenerateRelevanceFacts = (data) => {
 
  return async (dispatch) => {
   try {  
      const response = await getRRAxios("api/Reviews/RegenerateRelevanceFacts?reviewId="+data, {
         params: data
      });
      if(data)
      await  dispatch( fetchSimilarReviews(data));
    } catch (error) {
    }
  };
}


export const executeAgent=(reviewId)=>{
  return async (dispatch) => {
    dispatch(getReviewDataTopics());
    try {
      const response = await getRRAxios(
        "api/Reviews/RegenerateReviewerName?reviewId=" + reviewId,
        { params: {} }
      );
      if (response) {
        await dispatch( getSimilarReviews(reviewId));
      } 
    } catch (error) {
    }
  };
}


export function getActionLogs(companyId, reviewId, requestId) {
  return async (dispatch) => {
    dispatch(GetLogs());
    try {
      const params = { callTime: new Date() };
      const data = await getRRAxios(`api/Logs/GetRequestLogData?companyId=${companyId}&reviewId=${reviewId}&requestId=${requestId}`, {
        params: params,
      });
      dispatch(GetLogsSuccess(data));
    } catch (error) {
      dispatch(GetLogsFailure());
    }
  };
}


export const RegeneratePHI = (reviewId) => {
  return async (dispatch) => {
    dispatch(getReviewDataTopics());
    try {
      const response = await getRRAxios(
        "api/Reviews/RegeneratePHI?reviewId=" + reviewId,
        { params: {} }
      );
      if (response) {
        await dispatch(getSimilarReviews(reviewId));
      }
    } catch (error) {}
  };
};


export const RegenerateEmployeeName = (reviewId) => {
  return async (dispatch) => {
    dispatch(getReviewDataTopics());
    try {
      const response = await getRRAxios(
        "api/Reviews/RegenerateEmployeeName?reviewId=" + reviewId,
        { params: {} }
      );
      if (response) {
        await dispatch(getSimilarReviews(reviewId));
      }
    } catch (error) {}
  };
};


export const RegenerateInappropriateInstructions = (reviewId) => {
  return async (dispatch) => {
    dispatch(getReviewDataTopics());
    try {
      const response = await getRRAxios(
        "api/Reviews/RegenerateInappropriateInstructions?reviewId=" + reviewId,
        { params: {} }
      );
      if (response) {
        await dispatch(getSimilarReviews(reviewId));
      }
    } catch (error) {}
  };
};
